(() => {
  const sections = document.querySelectorAll('[data-index-architecture]');

  sections.forEach((section) => {
    const cards = section.querySelectorAll('[data-architecture-card]');
    if (!cards.length) return;

    const setActive = (activeCard) => {
      cards.forEach((card) => {
        card.classList.toggle('is-active', card === activeCard);
      });
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => setActive(card));
      card.addEventListener('focus', () => setActive(card));

      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (card.tagName === 'A') return;
        event.preventDefault();
        setActive(card);
      });
    });
  });
})();
